module.exports = __webpack_public_path__ + "static/img/game_left_in.d31b227.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_left_in.png
// module id = yJG4
// module chunks = 1